import { useState, useEffect } from "react";
import { GetCountries } from "../services/QalortServices";
import countriesData from "../assets/countries.json";
import { useDispatch } from "react-redux";
import { updatecountriesSlice } from "../store/slices/countriesSlice";
import { COUNTRIES } from "../constants/countries";

export const useCountries = () => {
  const [countries, setCountries] = useState([]);
  const [flagsInfo, setflagsInfo] = useState([]);
  const dispatch = useDispatch();

  const getCountries = async () => {
    const data = COUNTRIES; //await GetCountries();
    setCountries(data);
    dispatch(updatecountriesSlice(data));
  };

  useEffect(() => {
    setflagsInfo(countriesData);
    getCountries();
  }, []);

  return { countries, flagsInfo };
};
